import { useEffect, useState } from "react";
import {
  fetchSupportEligibility,
  DEFAULT_SUPPORT_ELIGIBILITY,
} from "../utils/fetchSupportEligibility";
import type { SupportEligibility } from "../types";

const useSupportEligibility = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [eligibility, setEligibility] = useState<SupportEligibility>(
    DEFAULT_SUPPORT_ELIGIBILITY,
  );
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEligibilityData = async () => {
      try {
        const result = await fetchSupportEligibility();
        setEligibility(result);
      } catch (err) {
        setError("An error occurred while fetching eligibility data.");
        console.error("Support eligibility fetch error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEligibilityData();
  }, []); // Empty dependency array to run only once

  return {
    isLoading,
    eligibility,
    error,
  };
};

export default useSupportEligibility;
